/**
 * Binds billing period toggle buttons.
 *
 * @param {Object} options Configuration object.
 * @param {NodeListOf<HTMLButtonElement>} options.buttons Billing toggle buttons.
 * @param {Function} options.onChange Callback fired after billing period change.
 * @return {void}
 */
export const bindBillingToggle = ( { buttons, onChange } ) => {

	/**
	 * Activates the selected billing toggle button.
	 *
	 * @param {HTMLButtonElement} activeButton Button that should become active.
	 * @return {void}
	 */
	const activateButton = ( activeButton ) => {

		const nextTerm = activeButton.dataset.term || 'annual';

		buttons.forEach( ( button ) => {

			const isActive = button === activeButton;

			button.classList.toggle( 'b-pricing-calculator__toggle-btn--active', isActive );
			button.setAttribute( 'aria-pressed', String( isActive ) );

		} );

		onChange( nextTerm );

	};

	buttons.forEach( ( button ) => {

		button.addEventListener( 'click', () => {

			activateButton( button );

		} );

	} );

};
